import { connect } from 'react-redux';
import Flowchart from 'flowchart-react';
import ListView from '../../../Utils/ListView';
import Highlighter from 'react-highlight-words';
import { encode as base64_encode } from 'base-64';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';

import { Tag, Input, Popconfirm, Tooltip, Drawer, message, Form, Select, Modal, Button } from 'antd';
import {
  NodeExpandOutlined,
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  ApartmentOutlined,
  PlusOutlined,
  EyeOutlined
} from '@ant-design/icons';
import {
  getWorkOrdersList,
  deleteWorkOrder,
  changeWorkOrderStatus,
  workOrderStatus,
  getWorkFlow,
  getWorkFlows,
  UpdateWorkFlow
} from '../../../Utils/FormCalls';

const { Option } = Select;

const WorkOrderList = (props) => {
  const [dataSource, setDataSource] = useState([]);
  const [visible, setVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [workFlow, setWorkFlow] = useState({});
  const [selectedId, setSelectedId] = useState('');
  const [searchText, setSearchText] = useState('');
  const [workFlowsList, setWorkFlowsList] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null); // Define selectedRecord state
  const WorkFlowModalRef = useRef(null);
  const searchRef = useRef(null);
  useEffect(() => {
    _getAdhocDataSource();
  }, []);

  useEffect(() => {
    let searchParams = new URLSearchParams(props.location.search);
    let newParams = Object.fromEntries([...searchParams]);
    if (selectedId !== newParams.id && newParams.id) {
      editWorkOrder(newParams);
    }
  }, [props.location.search, selectedId]);

  const _getAdhocDataSource = async () => {
    let dataSource = await getWorkOrdersList();
    setDataSource(dataSource);
    setSelectedId('');
  };


  const editWorkOrder = async (record) => {
    let redirectPathURL = '';
    if (record.WorkType === 'Emergency Maintenance') {
      redirectPathURL = '/rubus/AMM/EWODetails';
    } else if (record.WorkType === 'Common Work') {
      redirectPathURL = '/rubus/AMM/FieldDataMeasurementDetails';
    }
    props.navigate({ pathname: `${redirectPathURL}/${base64_encode(record.Id)}` });

  };


  const handleCancel = () => {
    setVisible(false);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchRef}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          danger
          style={{ width: 90 }}
          onClick={() => {
            clearFilters();
            confirm({
              closeDropdown: true
            });
          }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? '#1890ff' : undefined, }}
      />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const _deleteById = async (id) => {
    await deleteWorkOrder(id);
    let dataSource = await getWorkOrdersList();
    setDataSource(dataSource);
  };

  const changeStatus = async (id) => {
    await changeWorkOrderStatus(id);
    let dataSource = await getWorkOrdersList();
    setDataSource(dataSource);
  };

  const viewWorkFlow = async (record) => {
    setVisible(true);
    if (record && record.WorkFlowId && record.WorkFlowId !== null) {
      let NodeData = await getWorkFlow(record.WorkFlowId);
      setWorkFlow(NodeData[0].Node);
    }
  };

  const initateWorkOrder = async (record) => {
    let payload = {
      Id: record.Id,
      WorkFlowId: record.WorkFlowId,
      WfStatus: 'Submit',
      WorkTypeId: record.WorkTypeId,
      WorkOrderName: record.WorkOrder,
      RoleId: JSON.parse(localStorage.get('roleId'))
    };
    let initateWO = await workOrderStatus(payload);
    if (initateWO && initateWO.message) {
      message.success(`${initateWO.message}`);
      _getAdhocDataSource();
    }
  };

  const onModalCancel = () => {
    WorkFlowModalRef.current &&
      WorkFlowModalRef.current.setFieldsValue({
        WorkFlow: null
      });
    setModalVisible(false);
  };

  const onAddWorkFlow = async (record) => {
    let workFlowsList = await getWorkFlows(record.WorkTypeId);
    WorkFlowModalRef.current &&
      WorkFlowModalRef.current.setFieldsValue({
        WorkFlow: null
      });
    setModalVisible(true);
    setWorkFlowsList(workFlowsList);
    setSelectedRecord(record);
  };

  const onFinish = async (values) => {
    let UpdateWoFlow = await UpdateWorkFlow(selectedRecord.Id, values.WorkFlow);
    if (UpdateWoFlow && UpdateWoFlow.status === 200) {
      message.success(UpdateWoFlow.data.message);
      WorkFlowModalRef.current &&
        WorkFlowModalRef.current.setFieldsValue({
          WorkFlow: null
        });
      setModalVisible(false);
      _getAdhocDataSource();
    } else {
      message.error('Error');
    }
  };

  const columns = [
    {
      title: translation(props.translationCache, constant.workOrder),
      dataIndex: 'WorkOrder',
      key: 'WorkOrder',
      filter: true,
      ...getColumnSearchProps('WorkOrder')
    },
    {
      title: translation(props.translationCache, constant.description),
      dataIndex: 'Description',
      key: 'Description',
      ...getColumnSearchProps('Description', 'Description')
    },
    {
      title: translation(props.translationCache, constant.workType),
      dataIndex: 'WorkType',
      key: 'WorkType',
      ...getColumnSearchProps('WorkType', 'WorkType'),
      render: (text) => translation(props.translationCache, text)
    },
    {
      title: translation(props.translationCache, constant.site),
      dataIndex: 'SiteName',
      key: 'SiteName',
      filter: true
    },
    {
      title: translation(props.translationCache, constant.status),
      dataIndex: 'Status',
      key: 'Status',
      render: (text, record) => (
        <Tooltip title={`Click To ${text === 'Active' ? 'Inactive' : 'Active'}`}>
          <span onClick={() => changeStatus(record.Id)}>
            <Tag
              color={
                text === 'Active' ? '#87d068' : text === 'Inactive' ? '#ff4d4f' : 'gold'
              }
              key={text}
            >
              {translation(props.translationCache, text)}
            </Tag>
          </span>
        </Tooltip>
      )
    },
    {
      title: translation(props.translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          {record.WorkFlowId && record.WorkFlowId !== null ? (
            <>
              <Tooltip title="View WorkFlow">
                <Button
                  type='primary'
                  style={{ marginRight: '5px' }}
                  onClick={() => viewWorkFlow(record)}
                  icon={<ApartmentOutlined />}
                />
              </Tooltip>
              <Tooltip title="Initiate WorkFlow">
                <Button
                  style={{ marginRight: '5px' }}
                  disabled={record.RecordStatus !== null}
                  onClick={() => initateWorkOrder(record)}
                  icon={<NodeExpandOutlined />}
                />
              </Tooltip>
            </>
          ) : (
            <Tooltip title="Update WorkFlow">
              <Button
                type='primary'
                style={{ marginRight: '5px' }}
                onClick={() => onAddWorkFlow(record)}
                icon={<PlusOutlined />}
              />
            </Tooltip>
          )}

          {['Emergency Maintenance', 'Common Work'].includes(record.WorkType) &&
            ['WAPPR', 'APPR', 'INPRG', 'Rejected'].includes(record.Status) ? (
            <Button
              disabled={record.Status === 'Inactive'}
              style={{ marginRight: '5px' }}
              onClick={() => editWorkOrder(record)}
            >
              <Tooltip title={'Edit'}>
                <EditOutlined />
              </Tooltip>
            </Button>
          ) : null}
          {['Emergency Maintenance', 'Common Work'].includes(record.WorkType) &&
            ['COMP', 'CLOSE'].includes(record.Status) ? (
            <Button
              disabled={record.Status === 'Inactive'}
              style={{ marginRight: '5px' }}
              onClick={() => editWorkOrder(record)}
            >
              <Tooltip title={'View'}>
                <EyeOutlined />
              </Tooltip>
            </Button>
          ) : null}

          <Popconfirm
            title={translation(props.translationCache, 'Are you sure that you want to delete the WorkOrder')}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={() => _deleteById(record.Id)}
            okText={translation(props.translationCache, constant.yes)}
            cancelText={translation(props.translationCache, constant.no)}
          >
            <Button>
              <Tooltip title={'Delete'}>
                <DeleteOutlined />
              </Tooltip>
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <>
      <Drawer
        width={window.innerWidth > 19000 ? 18000 : window.innerWidth - 100}
        open={visible}
        onClose={handleCancel}
        title="WorkFlow Flow Chart"
      >
        <Flowchart
          showToolbar={false}
          style={{ width: '100%', height: 500, color: 'black' }}
          nodes={workFlow.nodes}
          connections={workFlow.connections}
        />
      </Drawer>
      <Modal
        open={modalVisible}
        width={800}
        closable={true}
        title={translation(props.translationCache, 'Update WorkFlow')}
        footer={null}
        onCancel={onModalCancel}
      >
        <Form
          name="WorkFlow"
          ref={WorkFlowModalRef}
          onFinish={onFinish}
          layout="horizontal"
          labelCol={{ flex: '200px' }}
          labelAlign="right"
          labelWrap
          wrapperCol={{ flex: 1 }}
        >
          <Form.Item
            label={translation(props.translationCache, 'Update WorkFlow')}
            name="WorkFlow"
            rules={[{ required: true }]}
          >
            <Select
              style={{ width: '70%' }}
              placeholder={translation(props.translationCache, 'Please Select WorkFlow')}
            >
              {workFlowsList.map((workFlow, index) => (
                <Option key={index} value={workFlow.Id}>
                  {workFlow.WorkFlowName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <div style={{ paddingLeft: '200px' }}>
            <Button htmlType="submit">
              {translation(props.translationCache, constant.submit)}
            </Button>
          </div>
        </Form>
      </Modal>
      <ListView
        columns={columns}
        dataSource={dataSource}
        config={{
          title: translation(props.translationCache, 'WorkOrder'),
          viewTypes: ['card', 'table'],
          defaultViewType: 'table',
          filterType: 'ByAttributeValue',
          attributeList: ['WorkOrder'],
          firstTitle: 'WorkOrder',
          secondTitle: 'CreatedBy',
          thirdTitle: 'newCreatedTime',
          actions: ['edit', 'delete'],
          edit: {
            byAttribute: 'Id',
            redirectURL: '/rubus/AMM/WorkOrderDetails',
            redirectDetailsURL: '/rubus/AMM/WorkOrderTaskDetails'
          },
          deletee: {
            byAttribute: 'Id'
          }
        }}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(WorkOrderList);